import { isMealBillAndroid } from "../../native/mealbill-android.mjs";
import { routeMobilePrint } from "../../native/automatic-print-routing.mjs";
import { utilTypes } from "../types";

export const toggleDrawer = () => {
  return {
    type: utilTypes.TOGGLE_DRAWER,
  };
};

export const toggleSocketConnected = () => {
  return {
    type: utilTypes.SOCKET_CONNECTED,
  };
};

export const toggleSocketDisconnected = () => {
  return {
    type: utilTypes.SOCKET_DISCONNECTED,
  };
};

export const toggleFullScreen = () => {
  return {
    type: utilTypes.TOGGLE_FULL_SCREEN,
  };
};

export const togglePrinting = () => {
  return {
    type: utilTypes.TOGGLE_PRINTING,
  };
};

export const toggleKOT = () => {
  return {
    type: utilTypes.TOGGLE_KOT,
  };
};

export const setPrintData = (data, printType) => {
  return {
    type: utilTypes.SET_PRINT_DATA,
    payload: { data: data, printType: printType },
  };
};

export const spoolBillToManager = (data) => {
  return {
    type: "SET_PRINT_DATA_FOR_ADMIN",
    isSocket: true,
    payload: data,
  };
};

// Preserve the established socket action for Manager printing; Android alone selects a destination.
export const setPrintDataForAdmin = (data) => {
  if (!isMealBillAndroid()) return spoolBillToManager(data);
  return (dispatch) => routeMobilePrint("bill", {
    direct: () => dispatch(setPrintData(data)),
    spool: () => dispatch(spoolBillToManager(data)),
  }).catch((error) => {
    window.alert(`Print error: ${error.message}`);
    return { ok: false, message: error.message };
  });
};

export const removePrintData = (data) => {
  return {
    type: utilTypes.REMOVE_PRINT_DATA,
  };
};
export const setKOTPrintData = (data) => {
  return {
    type: utilTypes.SET_KOT_PRINT_DATA,
    payload: data,
  };
};

export const removeKOTPrintData = (data) => {
  return {
    type: utilTypes.REMOVE_KOT_PRINT_DATA,
  };
};
